import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";
/**
 * @description:商品分类列表
 * @data 
 * @return {*}
 */
export const getProductListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/list`,
        method: 'GET',
        params
    })
}
/**
 * @description:商品分类列表
 * @data 
 * @return {*}
 */
export const getCategoryListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/categoryList`,
        method: 'GET',
        params
    })
}
/**
 * @description: 获取商品分类列表
 * 
 * @return {*}
 */

export const getCategoryFilterAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/category`,
        method: 'GET',
        params
    })
}

//创建商品
export const setproductAddAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/product/add`,
        method: 'POST',
        data
    })
}
//根据id查询详情
export const detailAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/detail`,
        method: 'GET',
        params
    })
}
//修改商品
export const setproductEditAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/product/edit`,
        method: 'POST',
        data
    })
}

export const detailinfoAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/info`,
        method: 'GET',
        params
    })
}
// export const getSubCategoryAPI = (params) => {
//     return request({
//         url: `${AUTH_BASE_URL}/product/category`,
//         method: 'get',
//         params
//     })
// }

// export function getCategoryAPI(id) {
//     return request({
//         url: '/category',
//         params: {
//             id
//         }
//     })
// }
/**
 * 获取树形分类
 */

export const getTreeCategoryListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/treeCategoryList`,
        method: 'GET',
        params
    })
}

/**
 * 查询模版列表
 * @param {} params 
 * @returns 
 */
export const getTemplateListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/template_list`,
        method: 'GET',
        params
    })
}
/**
 * 添加模版
 * @param {*} data 
 * @returns 
 */
export const addTemplateAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/product/add_template`,
        method: 'POST',
        data
    })
}
/**
 * 编辑模版
 * @param {} params 
 * @returns 
 */
export const setEditTemplateAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/product/edit_template`,
        method: 'POST',
        data
    })
}
/**
 * 删除模版
 * @param {} data 
 * @returns 
 */
export const setDelTemplateAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/product/del_template`,
        method: 'POST',
        data
    })
}
/**
 * 翻译多语言
 * @param {*} params 
 * @returns 
 */
export const getProductTranslationAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/product/translation`,
        method: 'GET',
        params
    })
}


